<small class="sr-only" id="form-dati-generali">Form Dati generali</small>
<form aria-labelledby="form-dati-generali" *ngIf="datiGeneraliForm && fascicolo && request" [formGroup]="datiGeneraliForm">
  <div class="row">

    <div class="col-sm-3">
      <p>
        <label for="tipo-fasc-datigen-lbl">Tipo fascicolo</label> <input id="tipo-fasc-datigen-lbl" class="form-control" type="text" disabled=""
          [value]="fascicolo && fascicolo.tipoFascicolo ? fascicolo.tipoFascicolo.label : 'nomeFascicolo'">
      </p>
    </div>
    <div class="col-sm-3">
      <p>
        <label for="pos-datigen-lbl">Posizione</label> <input id="pos-datigen-lbl" class="form-control" type="text" disabled=""
          [value]="fascicolo && fascicolo.posizione ? fascicolo.posizione : 'Creato da sistema'">
      </p>
    </div>
    <div class="col-sm-3">
      <p>
        <label for="vecchia-pos-datigen-lbl">Vecchia posizione</label> <input id="vecchia-pos-datigen-lbl" class="form-control" type="text" disabled=""
          [value]="fascicolo && fascicolo.vecchiaPosizione ? fascicolo.vecchiaPosizione : ''">
      </p>
    </div>
    <div class="col-sm-3">
      <p>
        <label for="stato-datigen-lbl">Stato</label> <input id="stato-datigen-lbl" class="form-control" type="text" disabled=""
          [value]="fascicolo && fascicolo.stato ? fascicolo.stato.label : 'Creato da sistema'">
      </p>
    </div>
  </div>
  <div class="row">

    <div comboModInput class="col-sm-4"
              [labelInput] = "'Visibilit&agrave;'"
              formControlName = "tipoVisibilita"
              [labelNoSelection] = "'Ereditata dalla pratica'"
              [labelOption] = "'label'"
              [optionsCombo] = "tipiVisibilitaOptions"
              [objectReference]="request.fascicolo.tipoVisibilita"
              [mandatory]="true"
              (onReturn)="request.fascicolo.tipoVisibilita = $event;
              datiGeneraliForm.controls['tipoVisibilita'].setValue($event)">
          </div>

    <div datePickerInput class="col-sm-4" [labelInput]="'Data apertura'"
      formControlName="dataInizioFascicolo" [dataAl]="request.fascicolo.dataDefinizione"
      [control]="datiGeneraliForm.controls['dataInizioFascicolo']" [(ngModel)]="request.fascicolo.dataInizioFascicolo"
      [mandatory]="true"></div>

      <div class="col-sm-4 d-flex align-items-center">
        <div datePickerInput 
             [labelInput]="'Data notifica'"
             formControlName="dataNotifica"
             [control]="datiGeneraliForm.controls['dataNotifica']" 
             [(ngModel)]="request.fascicolo.dataNotifica"
             [style.width]="!isPraticaPareristico ? '100%' : 'auto'"
             >
        </div>
        <i *ngIf="isPraticaPareristico && fascicolo?.tipoFascicolo?.endpoint === 'parere' && inserimento" class="pi pi-info-circle text-primary" style="position:absolute; left: 33%;"
          pTooltip="A partire da questa data verrà generata automaticamente un'attività con scadenza tra 20 giorni."
          tooltipPosition="right">
        </i>
      </div>
  </div>
  <div class="row mb-row" *ngIf="fascicolo.tipoFascicolo.categoria.id === 'GIUDIZIALE' || fascicolo.tipoFascicolo.categoria.id === 'ESECUZIONE'">
    <div *ngIf="isPraticaCivile === true || isPraticaLavoro === true" datePickerInput class="col-sm-6" [labelInput]="'Data prima comparizione'"
      formControlName="dataPrimaComparizione"
      [control]="datiGeneraliForm.controls['dataPrimaComparizione']" [(ngModel)]="request.fascicolo.dataPrimaComparizione">
    </div>

    <div *ngIf="isPraticaTributario === true || isPraticaAmministrativa === true" datePickerInput class="col-sm-6" [labelInput]="'Data deposito ricorso'"
      formControlName="dataDepositoRicorso"
      [control]="datiGeneraliForm.controls['dataDepositoRicorso']" [(ngModel)]="request.fascicolo.dataDepositoRicorso">
    </div>
  </div>
  <div class="row" *ngIf="fascicolo && (fascicolo.tipoFascicolo.categoria.id != 'CONSULENZA')">
    <div comboModInput class="col-sm-6" [labelInput]="'Natura'" [mandatory]="true"
    [control]="datiGeneraliForm.controls['natura']" formControlName="natura" [labelOption]="'label'"
    [ngModel]="request.fascicolo.natura" [objectReference]="request.fascicolo.natura"
    (onReturn)="request.fascicolo.natura = $event" [optionsCombo]="tipiNatura"></div>

  <div checkBoxRadio class="col-sm-6" [labelInput]="'Fondo rischi'"
    idInput="fondo_rischi" formControlName="flagFondoRischi" [objectReference]="request.fascicolo.flagFondoRischi"
    (onReturn)=" request.fascicolo.flagFondoRischi = $event; changedFondoRischiStateFn($event);  "></div>
  <!--<div checkBoxRadio class="col-sm-4" [labelInput]="'Recupero crediti'" idInput="recupero_crediti"
    formControlName="recuperoCrediti" [objectReference]="request.fascicolo.recuperoCrediti"
    (onReturn)="request.fascicolo.recuperoCrediti = $event"></div>-->
  </div>

  <div class="row" *ngIf="fascicolo.tipoFascicolo.categoria.id === 'ESECUZIONE' || fascicolo.tipoFascicolo.categoria.id === 'GIUDIZIALE' && isPraticaPareristico === false">
    <div checkBoxRadio class="col-sm-4" [labelInput]="'Costituzione'" formControlName="flagCostituzione"
      (onReturn)="request.fascicolo.flagCostituzione=$event; onFlagCostituzioneChange($event)"
      [objectReference]="request.fascicolo.flagCostituzione"  [idInput]="inserimento ? 'flagCostituzione-ins' : 'flagCostituzione-mod'">
    </div>
    <div comboModInput class="col-sm-4" [labelOption]="'label'" [labelInput]="'Motivazione'"
      [submitPending]="datiGeneraliForm.get('flagCostituzione').value"
      [mandatory]="!datiGeneraliForm.get('flagCostituzione').value"  formControlName="motivazione"
      [objectReference]="request.fascicolo.motivazione"
      (onReturn)="request.fascicolo.motivazione=$event; onMotivazioneChange($event);" [optionsCombo] ="motivazioneOptions">
    </div>
    <div datePickerInput class="col-sm-4" [labelInput]="'Data costituzione'"
      formControlName="dataCostituzione"
      [control]="datiGeneraliForm.controls['dataCostituzione']" [(ngModel)]="request.fascicolo.dataCostituzione">
    </div>
  </div>

  <div class="row">
    <div textAreaInput class="form-group col-xs-12 col-sm-12" [labelInput]="'Descrizione oggetto'"
      formControlName="descrizioneOggetto" [(ngModel)]="request.fascicolo.descrizioneOggetto" [mandatory]="true"></div>
  </div>


  <app-dati-generali-fascicolo-giudiziale-common *ngIf="fascicolo && (fascicolo.tipoFascicolo.categoria.id === 'GIUDIZIALE' || fascicolo.tipoFascicolo.categoria.id === 'ESECUZIONE')"
  [request]="request"
  [fascicolo]="fascicolo"
  [inserimento]="inserimento"
  [datiGeneraliForm]="datiGeneraliForm"
  [entities]="entities"></app-dati-generali-fascicolo-giudiziale-common>

</form>
